import React from "react"
import { InputText } from "primereact/inputtext"
import { Field } from "formik"
import { FormError } from "./formError"

const InputField = (props: Props) => {
  const {
    label,
    name,
    type,
    placeholder,
    containerClass,
    labelClass,
    errorClass,
    filter,
    disabled
  } = props
  return (
    <>
      <Field name={name}>
        {({
          field, // { name, value, onChange, onBlur }
          //form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          meta,
        }) => (
          <>
            <div className={containerClass}>
              {label && (
                <label
                  className={`md:w-3/12 xs:w-1/5 w-2/5 p-2 pl-0 text-right ${labelClass ? labelClass : ""}`}
                  htmlFor={name}
                >
                  {label}
                </label>
              )}
              <div className='md:w-9/12 xs:w-4/5 w-3/5 '>
                <InputText
                  className="w-full"
                  type={type}
                  placeholder={placeholder}
                  keyfilter={filter}
                  disabled={disabled}
                  {...field}
                />
                <div className={errorClass}>
                  <div>
                    {meta.touched && meta.error && (
                      <FormError error={meta.error} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Field>
    </>
  )
}

interface Props {
  label?: string
  placeholder?: string
  type: InputTypes
  name: string
  containerClass?: string
  labelClass?: string
  errorClass?: string
  filter?: FiltersTypes | any
  disabled?: boolean
}

export enum InputTypes {
  Number = "number",
  Email = "email",
  Password = "password",
  Text = "text",
}

export enum FiltersTypes {
  PositiveIntegers = "pint",
  Integers = "int",
  PositiveNumbers = "pnum",
  Numbers = "num",
  Hexadecimal = "hex",
  Email = "email",
  Alphabetic = "alpha",
  Alphanumeric = "alphanum",
}

export { InputField }
